// extracted by css-extract-rspack-plugin
export default {"wrapper":"Lv1J85sce2EktTVg"};